/* global angular */

/**
* gc.localstorage Module
* LocalStorage works pretty well on every browser, except Sarafi when it is in
* private browsing mode. Setting a cookie could be a workaround, but Safari disallows
* thrid domain cookies so it wouldn't work in an iframe.
*
* The solution here is to save in a standard JS variable (localStorageReplacement).
* It will not be kept if the page changes, but at least it will allow the user to
* log in and write a comment...
*/
angular
.module('gc.localstorage', [])

.service('LocalStorageService', ['Utils', function(Utils) {
  'use strict';
  var token = null;
  function isAuthSlave() {
    return Utils.getParameterByName('auth') === "slave"
  }

  this.getItem = function(key) {
    return store.get(key);
  };

  this.setItem = function(key, value) {
    store.set(key, value);
  };

  this.removeItem = function (key) {
    store.remove(key);
  };

  this.getToken = function() {
    if (isAuthSlave()) {
      return token;
    }
    return this.getItem('gc_token');
  };

  this.setToken = function(value) {
    if (isAuthSlave()) {
      token = value;
    }
    return this.setItem('gc_token', value);
  };

  this.removeToken = function () {
    if (isAuthSlave()) {
      token = null;
    }
    return this.removeItem('gc_token');
  };

  // remove old cookie
  Cookies.remove('gc_token')

}]);
